/**
 * Modal for confirming image deletion
 */
export class DeleteConfirmModal {
    constructor() {
        this.modal = null;
        this.message = null;
        this.onConfirm = null;
        this.createElement();
    }

    /**
     * Create the modal DOM element
     */
    createElement() {
        // Create backdrop
        this.modal = document.createElement('div');
        this.modal.id = 'delete-confirm-modal';
        this.modal.className = 'fixed inset-0 bg-black/70 backdrop-blur-sm z-[1003] hidden flex items-center justify-center';

        // Create modal content
        const modalContent = document.createElement('div');
        modalContent.className = 'bg-slate-800 rounded-xl shadow-2xl p-6 w-full max-w-md border border-red-700/50';

        // Icon
        const icon = document.createElement('div');
        icon.className = 'flex justify-center mb-4';
        icon.innerHTML = `
            <div class="w-16 h-16 bg-red-600/20 rounded-full flex items-center justify-center">
                <svg class="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
            </div>
        `;

        // Title
        const title = document.createElement('h3');
        title.className = 'text-xl font-semibold text-white mb-2 text-center';
        title.textContent = 'Confirmer la suppression';

        // Message
        this.message = document.createElement('p');
        this.message.className = 'text-slate-300 mb-6 text-center text-sm';

        // Buttons container
        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'flex gap-3';

        // Cancel button
        const cancelBtn = document.createElement('button');
        cancelBtn.className = 'flex-1 px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors';
        cancelBtn.textContent = 'Annuler';
        cancelBtn.addEventListener('click', () => this.hide());

        // Confirm button
        const confirmBtn = document.createElement('button');
        confirmBtn.className = 'flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-semibold';
        confirmBtn.textContent = 'Supprimer';
        confirmBtn.addEventListener('click', () => this.handleConfirm());

        buttonsContainer.appendChild(cancelBtn);
        buttonsContainer.appendChild(confirmBtn);

        modalContent.appendChild(icon);
        modalContent.appendChild(title);
        modalContent.appendChild(this.message);
        modalContent.appendChild(buttonsContainer);

        this.modal.appendChild(modalContent);
        document.body.appendChild(this.modal);

        console.log('✅ Delete confirm modal created');
    }

    /**
     * Show the modal
     */
    show(itemName, onConfirm) {
        this.onConfirm = onConfirm;
        this.message.textContent = `Êtes-vous sûr de vouloir supprimer "${itemName}" ? Cette action est irréversible.`;
        this.modal.classList.remove('hidden');
        console.log('🗑️ Delete confirm modal shown');
    }

    /**
     * Hide the modal
     */
    hide() {
        this.modal.classList.add('hidden');
        this.onConfirm = null;
        console.log('🗑️ Delete confirm modal hidden');
    }

    /**
     * Handle confirm action
     */
    handleConfirm() {
        if (this.onConfirm) {
            this.onConfirm();
        }
        this.hide();
    }

    /**
     * Remove the modal from DOM
     */
    dispose() {
        if (this.modal && this.modal.parentNode) {
            this.modal.parentNode.removeChild(this.modal);
            this.modal = null;
            console.log('✅ Delete confirm modal disposed');
        }
    }
}
